module.exports = __webpack_public_path__ + "./img/default.5ad4148e4ea0da710eace41c0b007bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/default.png
// module id = ./src/containers/Briefcase/entry/icons/default.png
// module chunks = 0